import validator from 'validator';

const validateAddPurchase = (data) => {
    let errors = {};

    const { ad_type_id,ad_sub_type_id} = data;

    // if (!ad_type_id) {
    //     errors.ad_type_id = 'Please Select Type';
    // } else 
    if (validator.isEmpty(ad_type_id)){
        errors.ad_type_id = '유형을 선택해주세요.';
    }
    // if (!ad_sub_type_id) {
    //     errors.ad_type_id = 'Please Select SubType ';
    // } else 
    if (validator.isEmpty(ad_sub_type_id)){
        errors.ad_sub_type_id = '서브 유형을 선택해주세요.';
    }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateAddPurchase;